import {
  Button,
  Label,
  ListBox,
  ListBoxItem,
  Popover,
  Select,
  SelectValue,
} from "react-aria-components";

export type DesignerFilterType =
  | "all"
  | "completed"
  | "due-today"
  | "open"
  | "overdue";

interface DesignerDropdownFilterProps {
  onFilterChange: (filter: DesignerFilterType) => void;
  selectedFilter: DesignerFilterType;
}

const filterOptions = [
  { id: "all", label: "All Requests" },
  { id: "completed", label: "Completed Requests" },
  { id: "open", label: "Open Requests" },
  { id: "overdue", label: "Overdue Requests" },
  { id: "due-today", label: "Due Today Requests" },
] as const;

export function DesignerDropdownFilter({
  onFilterChange,
  selectedFilter,
}: DesignerDropdownFilterProps) {
  const selectedOption = filterOptions.find((opt) => opt.id === selectedFilter);

  return (
    <Select
      className="flex items-center gap-2 max-lg:w-full max-lg:px-4 max-lg:py-1 lg:ml-6 lg:-mr-2"
      onSelectionChange={(key) => onFilterChange(key as DesignerFilterType)}
      selectedKey={selectedFilter}
    >
      <Label className="sr-only">Filter requests</Label>
      <Button className="flex items-center gap-2 px-4 py-2 bg-bg-primary border border-border-primary rounded-md hover:bg-bg-secondary focus:outline-none focus:ring-2 focus:ring-border-brand max-lg:w-full max-lg:justify-between">
        <SelectValue className="text-sm font-medium text-text-primary">
          {selectedOption?.label || "All Requests"}
        </SelectValue>
        <span aria-hidden="true" className="text-text-tertiary">
          ▼
        </span>
      </Button>
      <Popover className="bg-bg-primary border border-border-primary rounded-md shadow-lg min-w-[200px] mt-1">
        <ListBox className="outline-none p-1">
          {filterOptions.map((option) => (
            <ListBoxItem
              className={({ isFocused, isSelected }) =>
                `px-3 py-2 text-sm cursor-pointer rounded outline-none ${
                  isSelected
                    ? "bg-bg-brand-subtle text-text-primary font-medium"
                    : isFocused
                      ? "bg-bg-secondary text-text-primary"
                      : "text-text-primary"
                }`
              }
              id={option.id}
              key={option.id}
            >
              {option.label}
            </ListBoxItem>
          ))}
        </ListBox>
      </Popover>
    </Select>
  );
}
